import { render } from "./Summary.vue?vue&type=template&id=4f3f846f&scoped=true"
import script from "./Summary.vue?vue&type=script&lang=js"
export * from "./Summary.vue?vue&type=script&lang=js"
script.render = render
script.__scopeId = "data-v-4f3f846f"

export default script